import React from "react";

export function Videos() {
    return (
        <center>
        <div class="right2">
        <br/>
        <br/>
        Fire Is Fast
    <iframe
        width="600"
        height="450"
        loading="lazy"
        allowfullscreen="true"
        webkitallowfullscreen="true" mozallowfullscreen="true"
        referrerpolicy="no-referrer-when-downgrade"
        src="https://diuy0t6boke2n.cloudfront.net/FirePreventionVideos/FireIsFast.mp4">
    </iframe>
    Home Fire Evacuation 3rd Grade
    <iframe
        width="600"
        height="450"
        loading="lazy"
        allowfullscreen="true"
        webkitallowfullscreen="true" mozallowfullscreen="true"
        referrerpolicy="no-referrer-when-downgrade"
        src="https://diuy0t6boke2n.cloudfront.net/FirePreventionVideos/Home_Fire_Evacuation_3rd_Grade.mp4">
    </iframe>
    Middlesex County Fire Prevention
    <iframe
        width="600"
        height="450"
        loading="lazy"
        allowfullscreen="true"
        webkitallowfullscreen="true" mozallowfullscreen="true"
        referrerpolicy="no-referrer-when-downgrade"
        src="https://diuy0t6boke2n.cloudfront.net/FirePreventionVideos/Middlesex_County_Fire_Prevention.mp4">
    </iframe>
    Sparkys ABCs of Fire Safety
    <iframe
        width="600"
        height="450"
        loading="lazy"
        allowfullscreen="true"
        webkitallowfullscreen="true" mozallowfullscreen="true"
        referrerpolicy="no-referrer-when-downgrade"
        src="https://diuy0t6boke2n.cloudfront.net/FirePreventionVideos/Sparkys_ABCs_of_Fire_Safety.mp4">
    </iframe>
    Stop Drop Roll
    <iframe
        width="600"
        height="450"
        loading="lazy"
        allowfullscreen="true"
        webkitallowfullscreen="true" mozallowfullscreen="true"
        referrerpolicy="no-referrer-when-downgrade"
        src="https://diuy0t6boke2n.cloudfront.net/FirePreventionVideos/StopDropRoll.mp4">
    </iframe>
    Home Fire Evacuation
    <iframe
        width="600"
        height="450"
        loading="lazy"
        allowfullscreen="true"
        webkitallowfullscreen="true" mozallowfullscreen="true"
        referrerpolicy="no-referrer-when-downgrade"
        src="https://diuy0t6boke2n.cloudfront.net/FirePreventionVideos/Home_Fire_Evacuation.mp4">
    </iframe>
    </div>
    </center>
    
    )
}